import React from "react";
import MasjidPicker from "./MasjidPicker";
import { toHomeMasjid } from "./masjidIndex";
import { HomeMasjid, MAX_FAVOURITES } from "./homeSettings";

interface SearchSheetProps {
  favourites: HomeMasjid[];
  onView: (masjid: HomeMasjid) => void;
  // Missing in the preview, which holds one masjid.
  onAdd?: (masjid: HomeMasjid) => void;
  onClose: () => void;
  // Live now and Listen buttons, from the live audio component.
  liveNow?: React.ReactNode;
  renderListen?: (masjid: HomeMasjid) => React.ReactNode;
}

// Any masjid, not just favourites: view its screen for a while, or add it.
const SearchSheet: React.FC<SearchSheetProps> = ({
  favourites,
  onView,
  onAdd,
  onClose,
  liveNow,
  renderListen,
}) => {
  const favouriteIds = favourites.map((m) => m.id);
  const full = favourites.length >= MAX_FAVOURITES;

  return (
    <div className="hs-sheet" role="dialog" aria-modal="true" aria-label="Find a masjid">
      <header className="hs-sheet-head">
        <h1>Find a masjid</h1>
        <button className="hs-close" onClick={onClose} aria-label="Close">
          ✕
        </button>
      </header>
      <div className="hs-sheet-body">
        {liveNow}
        <MasjidPicker
          autoFocus
          renderActions={(found) => {
            const masjid = toHomeMasjid(found);
            return (
              <>
                {renderListen?.(masjid)}
                <button className="hs-button" onClick={() => onView(masjid)}>
                  View
                </button>
                {onAdd && !favouriteIds.includes(masjid.id) && !full && (
                  <button className="hs-button" onClick={() => onAdd(masjid)}>
                    ☆ Add
                  </button>
                )}
              </>
            );
          }}
        />
        {full && (
          <p className="hs-note">
            You have {MAX_FAVOURITES} favourites. Remove one in Settings to add another.
          </p>
        )}
      </div>
    </div>
  );
};

export default SearchSheet;
